@switch (type) {
  @case ('POSITIF') {
    <div class="pr-sum-item">
      <div class="pr-sum-icon">
        <span class="positif">
          <pr-icon name="fa-caret-up" width="12"></pr-icon>
        </span>
      </div>
      <div class="pr-sum-label">{{ label }}</div>
      <div class="pr-sum-value">
        @if (value) {
          {{ showSign(value, '+') }} {{ value }}
        }
      </div>
    </div>
  }
  @case ('NEUTRAL') {
    <div class="pr-sum-item">
      <div class="pr-sum-icon">
        <span class="neutral">
          <pr-icon name="fa-caret-up" width="12"></pr-icon>
        </span>
      </div>
      <div class="pr-sum-label">{{ label }}</div>
      <div class="pr-sum-value">
        @if (value) {
          {{ showSign(value, '+') }} {{ value }}
        }
      </div>
    </div>
  }
  @case ('NEGATIF') {
    <div class="pr-sum-item">
      <div class="pr-sum-icon">
        <span class="negatif">
          <pr-icon name="fa-caret-down" width="12"></pr-icon>
        </span>
      </div>
      <div class="pr-sum-label">{{ label }}</div>
      <div class="pr-sum-value">
        @if (value) {
          {{ showSign(value, '-') }} {{ value }}
        }
      </div>
    </div>
  }
  @case ('NEGATIF_UNSIGNED') {
    <div class="pr-sum-item">
      <div class="pr-sum-icon">
        <span class="negatif">
          <pr-icon name="fa-caret-up" width="12"></pr-icon>
        </span>
      </div>
      <div class="pr-sum-label">{{ label }}</div>
      <div class="pr-sum-value">
        @if (value) {
          {{ showSign(value, '+') }} {{ value }}
        }
      </div>
    </div>
  }
  @case ('TOTAL') {
    <div class="pr-sum-total">
      <div class="pr-sum-total-label">{{ label }}</div>
      <div class="pr-sum-total-value">
        @if (value) {
          {{ value }}
        }
      </div>
    </div>
  }
  @case ('TOTALNEG') {
    <div class="pr-sum-total">
      <div class="pr-sum-total-label">{{ label }}</div>
      <div class="pr-sum-total-value-neg">
        @if (value) {
          {{ value }}
        }
      </div>
    </div>
  }
  @case ('BLANK') {
    <div class="pr-sum-item">&nbsp;</div>
  }
  @case ('SEP') {
    <hr />
  }
}
